import { useState } from 'react';
import { Link } from 'react-router-dom';
import { products, productCategories } from '../../../mocks/products';

export default function ProductsGrid() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filtered = activeCategory === 'all' ? products : products.filter((p) => p.category === activeCategory);

  return (
    <section id="product-grid" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Filter */}
        <div className="flex flex-wrap gap-2 mb-10">
          <button
            onClick={() => setActiveCategory('all')}
            className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-bold transition-all cursor-pointer ${activeCategory === 'all' ? 'bg-[#0B5C4D] text-white' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'}`}
          >
            All Products
          </button>
          {productCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`whitespace-nowrap flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-bold transition-all cursor-pointer ${activeCategory === cat.id ? 'bg-[#0B5C4D] text-white' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'}`}
            >
              <i className={`${cat.icon} text-sm`} />
              {cat.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((product) => (
            <Link
              key={product.id}
              to={`/products/${product.slug}`}
              className="group bg-white border border-stone-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 cursor-pointer"
            >
              <div className="relative h-64 bg-stone-50 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {product.badge && (
                  <span className="absolute top-3 left-3 bg-[#FF6B35] text-white text-xs font-bold px-3 py-1 rounded-full">
                    {product.badge}
                  </span>
                )}
              </div>
              <div className="p-6">
                <h2 className="text-stone-900 font-bold text-base mb-1 group-hover:text-[#0B5C4D] transition-colors">
                  {product.name}
                </h2>
                <p className="text-stone-500 text-sm mb-3">{product.tagline}</p>
                <div className="flex items-center gap-1.5 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-yellow-400 text-xs" />
                  ))}
                  <span className="text-stone-400 text-xs">({product.reviewCount.toLocaleString()})</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-stone-900 font-black text-xl">${product.price}</span>
                    {product.originalPrice && (
                      <span className="text-stone-400 text-sm line-through">${product.originalPrice}</span>
                    )}
                  </div>
                  <span className="text-[#0B5C4D] font-bold text-sm group-hover:text-[#FF6B35] transition-colors flex items-center gap-1">
                    Shop Now <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
